import { render, staticRenderFns } from "./CompletedOverlay.vue?vue&type=template&id=42527e64&scoped=true&"
import script from "./CompletedOverlay.vue?vue&type=script&lang=js&"
export * from "./CompletedOverlay.vue?vue&type=script&lang=js&"
import style0 from "./CompletedOverlay.vue?vue&type=style&index=0&id=42527e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42527e64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
